import { useDispatch, useSelector } from "react-redux";
import {
    setCurrentPage,
    setSearchTerm,
    setRowsPerPage,
    submittingData,
    submitDataFail,
    submitDataSuccess,
    fetchingData,
    fetchDataSuccess,
    fetchDataFail,
    reloadDialogState,
} from "./_reducer";
import ApiRequest from "../../utils/apiRequest";
import { API_URL } from "../../configs/_api";

const useLanguageActions = () => {
    const dispatch = useDispatch();

    const currentPage = useSelector((state) => state.language.currentPage);
    const rowsPerPage = useSelector((state) => state.language.rowsPerPage);
    const searchTerm = useSelector((state) => state.language.searchTerm);

    function getAllLanguage() {
        dispatch(fetchingData);

        const getLanguageListUrl = `${API_URL.Language}/all`;

        ApiRequest.get(getLanguageListUrl)
            .then(res => {
                const data = res.data.payload.data;
                const {total_items} = res.data.payload.metadata;  

                dispatch(fetchDataSuccess({data, total_items}));
            }).catch(err => {
                const errMsg = err.response?.data.errors?.message??  `${err.message}`
                dispatch(fetchDataFail(errMsg))
            })
    }

    function getLanguageByFilter() {
        dispatch(fetchingData());
        const getLanguageListUrl = `${API_URL.Language}?search_term=${searchTerm}&page_no=${currentPage + 1}&page_size=${rowsPerPage}`;

        ApiRequest.get(getLanguageListUrl)
            .then(res => {
                const data = res.data.payload.data;
                const {total_items} = res.data.payload.metadata;  

                dispatch(fetchDataSuccess({data, total_items}));
            }).catch(err => {
                const errMsg = err.response?.data.errors?.message??  `${err.message}`
                dispatch(fetchDataFail(errMsg))
            })
    }

    async function getLanguageDetail (id) {
        dispatch(fetchingData());
        const url = `${API_URL.Language}/${id}`;

        try {
            const res = await ApiRequest.get(url);
            const data = res.data.payload.data;
            dispatch(fetchDataSuccess({}));
            return data;
        } catch (err) {
            const errMsg = err.response?.data.errors?.message ??  `${err.message}`
            dispatch(fetchDataFail(errMsg))
            return Promise.reject(errMsg);
        }
    }

    async function createLanguage (data) {
        dispatch(submittingData());
        const url = `${API_URL.Language}`;

        try {
            const res = await ApiRequest.post(url, data);
            const language = res.data
            dispatch(submitDataSuccess())
            return language
        } catch (err) {
        const errors = {};
            errors.data = err?.response?.data?.errors?.data;
            dispatch(submitDataFail(err.response.data.errors.message));
            return Promise.reject(errors);
        }
    }

    async function updateLanguage (data) {
        dispatch(submittingData());
        const url = `${API_URL.Language}/edit`;

        try {
            const res = await ApiRequest.post(url, data);
            const language = res.data
            dispatch(submitDataSuccess())
            return language
        } catch (err) {
            const errors = {};
            errors.data = err?.response?.data?.errors?.data;
            dispatch(submitDataFail(err.response.data.errors.message));
            return Promise.reject(errors);
        }
    }

    async function setDefaultLanguage (id) {
        dispatch(submittingData());
        const url = `${API_URL.Language}/${id}`;

        try {
            const res = await ApiRequest.put(url);
            const data = res.data.payload.data;

            dispatch(fetchDataSuccess({}));
            return data;
        } catch (err) {
            const errMsg = err.response?.data.errors?.message ??  `${err.message}`
            dispatch(fetchDataFail(errMsg))
            return Promise.reject(errMsg);
        }
    }

    function changeSearchTerm(search_key) {
        dispatch(setCurrentPage(0));
        dispatch(setSearchTerm(search_key));
    }

    function changeCurrentPage(pageNo) {
        dispatch(setCurrentPage(pageNo));
    }

    function changeRowsPerPage(rowsPerPage) {
        dispatch(setCurrentPage(0));
        dispatch(setRowsPerPage(rowsPerPage));
    }

    function refreshDialogState() {
        dispatch(reloadDialogState());
    }

    return {
        // Actions
        getAllLanguage,
        getLanguageByFilter,
        getLanguageDetail,
        createLanguage,
        updateLanguage,
        setDefaultLanguage,
        changeSearchTerm,
        changeCurrentPage,
        changeRowsPerPage,
        refreshDialogState
    };
};

export default useLanguageActions;
